<template>
    <div>
        <sub-header :backButton="true" />
        <div class="flex min-w-full flex-1 justify-center items-center py-10" v-if="loading">
            <Loader :loading="loading" />
        </div>
        <div v-else class="flex flex-1 flex-col flex-grow max-h-full max-w-full overflow-auto scroll-bar mx-6 min-h-full">
            <div class="card bg-white rounded-md shadow p-6 flex flex-row gap-5 mb-6 items-center">
                <div class="flex flex-col gap-2 w-5/12">
                    <span class="text-gray-500 text-md"> Group Name </span>
                    <neo-input class="h-11" placeholder="Group Name" bg="white" v-model="groupname" name="groupname"> </neo-input>
                </div>

                <div class="flex flex-col gap-2 w-6/12">
                    <span class="text-gray-500 text-md"> Group Description </span>
                    <textarea class="rounded-lg textarea-bordered textarea textarea h-8 min-w-full resize-none" placeholder="Group Description" v-model="groupdescription" name="groupdescription"> </textarea>
                </div>
                <div class="flex-1 flex gap-5 w-2/12 items-center">
                    <span class="text-gray-500 text-md"> </span>
                    <div class="flex mt-7 gap-4">
                        <button class="h-10 w-10 flex justify-center items-center rounded-full bg-gray-100 hover:bg-gray-200" @click="updateGrp">
                            <font-awesome-icon icon="save" class="text-primary text-xl cursor-pointer" />
                        </button>
                        <button class="h-10 w-10 bg-gray-100 flex justify-center rounded-full items-center hover:bg-gray-200" @click="deleteGroup">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="text-red-600 hover:text-red-700 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <div class="relative bg-white rounded-md shadow p-6 flex flex-col gap-5">
                <div class="flex justify-end">
                    <Button type="primary" text="Add User" class="w-36" @click="showAddUserModal" />
                </div>
                <div style="display: flex; justify-content: space-between; align-items: start; height: 100%">
                    <div class="flex gap-6 flex-col" style="flex-grow: 1">
                        <vue-good-table
                            :rows="items"
                            :columns="columns"
                            :pagination-options="{
                                enabled: true,
                                mode: 'records',
                            }"
                        >
                            <template slot="table-row" slot-scope="props">
                                <div v-if="props.column.field === 'actions'" :class="[props.row.system_default && 'default hover-text']" class="flex justify-center gap-3">
                                    <button @click="removeUser(props.row.id)" class="h-6 w-6">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="text-red-600 hover:text-red-700">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                        </svg>
                                    </button>
                                </div>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <!-- delete popup confirm -->

        <modal-confirm title="Are you sure?" message="Please confirm you're about to delete the field." ref="confirm-popup"> </modal-confirm>
        <ListModal ref="add-user-modal" @handleFilterResult="handleFilterResult($event)" :lists="getFilteredUsers" :isLoading="loadingState.fetchingUsers" modalTitle="Add User">
            <template #item="{ item }">
                <div class="flex items-center flex-1 justify-between">
                    <span class="truncate">{{ item.user_name }}</span>
                    <Button type="primary" class="btn-xs" text="Add" @click="assignUserToGroup(item)" :disabled="loadingState && loadingState.assignUser"> </Button>
                </div>
            </template>
        </ListModal>
    </div>
</template>
<script>
import SubHeader from "@/components/SubHeader";
import axios from "@/axios";
import Input from "@/components/input";
import Button from "@shared/components/button";
import Loader from "@/components/loader";

const modalConfirm = () => import("@/components/modal-confirm");
import ListModal from "@shared/components/listModal";

// import dvTable from "@/components/devliumComponent/field-table/dv-table";
export default {
    name: "field-table-data-view",
    components: {
        // dvTable,
        SubHeader,
        "neo-input": Input,
        Button,
        modalConfirm,
        Loader,
        ListModal,
    },
    props: {},
    data: () => ({
        columns: [
            {
                label: "User Name",
                field: "user_name",
                filterOptions: {
                    enabled: true, // enable filter for this column
                },
            },
            {
                label: "User Email",
                field: "email",
                filterOptions: {
                    enabled: true, // enable filter for this column
                },
            },
            { label: "", field: "actions" },
        ],
        loading: false,
        items: [],
        group_id: "",
        user_id: "",
        user_count: 0,
        groupname: "",
        active: true,
        clients: "",
        groupdescription: "",
        fieldTypeIcon: null,
        error: null,
        loadingState: {
            fetchingUsers: false,
            assignUser: false,
        },
        usersList: [],
        client_id: null,
        searchState: {
            userSearch: "",
        },
    }),
    async mounted() {
        this.loading = true;
        if (!this.$store.getters.getClientId) {
            await this.$store.dispatch("fetchClientId");
        }
        this.client_id = this.$store.getters.getClientId;
        await this.getUsersList();
        this.group_id = this.$route.params?.id;
        await this.getGroupDetails();
        try {
            let groupUsers = await axios.get(`group/user/group_id/${this.group_id}`);
            this.items = groupUsers.data;
            console.log(this.items);
            this.user_id = this.items.id;
        } catch (error) {
            console.log("error", error);
        }
        this.loading = false;
    },
    computed: {
        getFilteredUsers() {
            return this.usersList.filter((user) => user?.user_name?.toLowerCase().includes(this.searchState?.userSearch?.toLowerCase()) && !this.items.some((group_user) => group_user.id === user.id));
            // return this.usersList.filter(el => el.user_name?.toLowerCase()?.includes(this.searchState.userSearch.toLowerCase()))
        },
    },
    methods: {
        // updateGrp() {
        //   rows.find((e) => e.id == this.$route.params.id).group_name =
        //     this.groupname;
        //   rows.find((e) => e.id == this.$route.params.id).clients = this.clients;
        //   rows.find((e) => e.id == this.$route.params.id).group_description =
        //     this.groupdescription;
        //   this.$router.back();
        // },
        async getGroupDetails() {
            let url = `group/client/${this.client_id}/group/${this.group_id}`;
            try {
                let { data } = await axios.get(url);
                this.groupname = data.title;
                this.groupdescription = data.description;
            } catch (error) {
                console.log(error, "Error");
            }
        },
        async removeUser(id) {
            const promise = await this.$refs["confirm-popup"].show({
                title: "Are you sure?",
                message: "This user  will be deleted permanently. Please confirm to continue deleting this user.",
            });
            if (promise) {
                try {
                    let { data } = await axios.delete(`group/group_id/${this.group_id}/user/${id}/client`);
                    this.$toast.success(data.message || "user deleted");
                    const finalData = this.items.filter((x) => x.id !== id);
                    this.items = finalData;
                    // location.reload();
                } catch (error) {
                    this.$toast.error(error.response.data.detail || "Failed to remove user");
                    console.log("error", error);
                }
            }
            this.$refs["confirm-popup"].close();
        },
        async deleteGroup() {
            const promise = await this.$refs["confirm-popup"].show({
                title: "Are you sure?",
                message: "This group  will be deleted permanently. Please confirm to continue deleting this group.",
            });
            if (promise) {
                try {
                    let { data } = await axios.delete(`group/client/${this.client_id}/group_id/${this.group_id}/client`);
                    this.$toast.success(data.message || "Group Deleted");
                    this.$router.back();
                } catch (error) {
                    this.$toast.error(error.response.data.detail || "Failed to delete group");
                    console.log("error", error);
                }
            }
            this.$refs["confirm-popup"].close();
        },
        async updateGrp() {
            try {
                let { data } = await axios.put(`group/client/${this.group_id}`, {
                    title: this.groupname,
                    description: this.groupdescription,
                    active: this.active,
                    client_id: this.client_id,
                });
                this.$toast.success(data.message || "Group updated");
            } catch (error) {
                this.$toast.error(error.response.data.detail || "Failed to delete group");
                console.log("error", error);
            }
        },
        async showAddUserModal() {
            this.$refs["add-user-modal"].showListModal();
            this.searchState.userSearch = "";
            this.loadingState.assignUser = false;
            await this.getUsersList();
        },
        async getUsersList() {
            this.loadingState.fetchingUsers = true;
            try {
                let { data } = await axios.get(`user/client/${this.client_id}`);
                this.usersList = data;
            } catch (error) {
                console.log(error, "<<<<error while fetching users");
            }
            this.loadingState.fetchingUsers = false;
        },
        handleFilterResult(value) {
            this.searchState.userSearch = value;
        },
        async assignUserToGroup(user) {
            this.loadingState.assignUser = true;
            try {
                let url = `/group/client/user`;
                let payload = {
                    user_id: user.id,
                    group_id: this.group_id,
                };
                let { data } = await axios.post(url, payload);
                this.items.push(user);
                this.$toast.success(data.message || "user added to group");
                console.log(data, ">>>>data");
            } catch (error) {
                this.$toast.error(error.response.data.detail || "Failed to add user to group");
            }
            this.loadingState.assignUser = false;
        },
    },
};
</script>
<style scoped lang="scss">
@import "@shared/assets/mixins/mixins.scss";
@include tableComponent;
</style>
